// Global type definitions for the Snow Web application

import { SimpleLatLng } from "../components/SiteMap/Core";
import { Address, JobServiceOption } from "../services/axios/jobs";
import { JobBulkUpdatePayload } from "@mysnowscape/snow-lib";

// DEBT: we will have to update JobBulkUpdatePayload in snow-lib to support this to simplify it
export type JobBulkUpdateData = JobBulkUpdatePayload["data"] & {
  servicesToAdd?: string[];
  servicesToRemove?: string[];
};

export interface SelectiveJobBulkUpdatePayload
  extends Omit<JobBulkUpdatePayload, "data"> {
  data: JobBulkUpdateData;
}

export interface User {
  _id: string;
  email?: string;
  firstName: string;
  lastName: string;
  uid?: string;
  phoneNumber: string;
  stripe?: {
    customerId?: string;
  };
}

export interface Company {
  _id: string;
  name: string;
  address: string;
  phoneNumber: string;
  email: string;
  ownerUid: string;
  createdAt: string;
  timezone?: string;
  commonCompanyServices: Record<Season, Array<JobServiceOption>>;
  authorizedUsers: Record<
    string,
    {
      _id: string;
      firstName: string;
      lastName: string;
      active: boolean;
    }
  >;
}

export interface Job {
  id: string;
  companyId: string;
  location?: {
    lat: number;
    lng: number;
  };
  snow?: JobSeasonProperties;
  landscape?: JobSeasonProperties;
}
export interface JobHistory {
  _id: string;
  completedJobImages: Array<{ uri: string; note: string }>;
  season: Season;
  servicesPerformed: Array<JobServiceOption>;
  address: Address;
  companyId: string;
  completedBy: User;
  endTime: string;
  flaggedForReview: boolean;
  instructions: string;
  jobId: string;
  name: string;
  notes: string;
  location: {
    lat: number;
    lng: number;
  };
  startTime: string;
  startTimeUTC: string;
  endTimeUTC: string;
  weatherCondition: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any; // There are a lot of other properties too.  Feel free to remove this line if you define all of them.
}
export interface JobSeasonProperties {
  sitemapNeedsNewImage?: boolean;
  siteMapGeoJson?: string;
  primarySitemap?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any; // There are a lot of other properties too.  Feel free to remove this line if you define all of them.
}

// API Response types
export interface ApiResponse<T> {
  data: T;
  message: string;
  success: boolean;
}

// Form types
export interface LoginFormData {
  email: string;
  password: string;
}

export interface SignUpFormData {
  email: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

export enum Season {
  landscape = "landscape",
  snow = "snow",
}

export interface TimeRecord {
  _id: string;
  companyId: string;
  userId: string;
  startTime?: Date | null;
  endTime?: Date | null;
  wasEdited?: boolean;
  submittedBy: {
    uid: string;
    firstName: string;
    lastName: string;
  };
  crewLocationStart?: SimpleLatLng;
  crewLocationEnd?: SimpleLatLng;
  createdAt: string;
  updatedAt: string;
}
